const recentlyViewed = JSON.parse(localStorage.getItem('globoRecentlyViewedProducts'));
let viewed_products = [];
const max_results = 8;

if(recentlyViewed !== null) {
    for(let i = 0; i < recentlyViewed.length; i++) {
        if(viewed_products.length < max_results) {
            let newProduct = {
                title: recentlyViewed[i]['title'],
                num_variants: recentlyViewed[i]['variants'].length,
                main_image: recentlyViewed[i]['images'][0],
                product_url: getProductURL(recentlyViewed[i]['handle']),
                price_from: null,
                price_to: null,
                price: null,
                on_sale: null
            }
            newProduct.on_sale = recentlyViewed[i]['compare_at_price'] !== null && recentlyViewed[i]['compare_at_price'] > recentlyViewed[i]['price'];
            if(recentlyViewed[i]['variants'].length >= 2) {
                let variantPrices = [];
                for(let x =0; x < recentlyViewed[i]['variants'].length; x++) {
                    variantPrices.push(parseInt(recentlyViewed[i]['variants'][x]['price']));
                }
                newProduct.price_from = formatPrice(Math.min(...variantPrices));
                newProduct.price_to = formatPrice(Math.max(...variantPrices));
            } else {
                newProduct.price = formatPrice(recentlyViewed[i]['price']);
            }
            viewed_products.push(newProduct);
        } else {
            break;
        }
    }
}

function getProductPrice(arrayID) {
    return viewed_products[arrayID].price ? currencySymbol() + viewed_products[arrayID].price : `${currencySymbol() +viewed_products[arrayID].price_from } - ${currencySymbol() + viewed_products[arrayID].price_to }`;
}

function formatPrice(price) {
    let convertedPrice = (price/100.0).toFixed(2);
    
    let parts = convertedPrice.split('.');
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ',');
    let cents = parts[1] ? ('.' + parts[1]) : '';

    return dollars + cents;
}

function currencySymbol() {
    return document.getElementById('recently-viewed-container').dataset.currencySymbol;
}

function getProductURL(handler) {
    let rootDomain = window.location.origin;
    return `${rootDomain}/products/${handler}`;
}